import React from 'react'
import './styles.scss'

const ExperienceCard = (props) => {
  return (
    <div className="experience-card">
      <h6>{props.name}</h6>
      <div className="card">
        <div className="head-title">
          <p>Field</p>
          <p>Experience</p>
        </div>
        {props.experiences.map((item, index) => (
          <div key={index} className="content-card">
            <div className="frame-title-description">
              <p className="p-title">{item.title}</p>
              <p className="p-description">{item.description}</p>
            </div>
            <p className="p-years">{item.years}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ExperienceCard
